/* CourtKraze interaction engine — vanilla JS, no dependencies.
   Ported from the CourtKraze Home v2 blueprint. Safe to re-run: every init is
   idempotent so it also works on shopify:section:load in the theme editor. */
(function () {
  'use strict';

  var doc = document;
  var root = doc.documentElement;
  var qs = function (s, c) {
    return (c || doc).querySelector(s);
  };
  var qsa = function (s, c) {
    return Array.prototype.slice.call((c || doc).querySelectorAll(s));
  };
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia && matchMedia('(pointer:fine)').matches;
  var hoverCapable = window.matchMedia && matchMedia('(hover:hover)').matches;
  var cfg = window.ckConfig || {};
  var fx = cfg.motion !== false && !reduce;
  var clamp = function (v, a, b) {
    return Math.max(a, Math.min(b, v));
  };
  var once = function (el, key) {
    if (el['_ck_' + key]) return false;
    el['_ck_' + key] = true;
    return true;
  };

  /* ---------------- theme ---------------- */
  function setTheme(t) {
    root.setAttribute('data-ck-theme', t);
    try {
      localStorage.setItem('ck-theme', t);
    } catch (e) {}
    qsa('[data-ck-theme-toggle]').forEach(function (b) {
      b.setAttribute('aria-pressed', t === 'light');
    });
  }
  doc.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-ck-theme-toggle]');
    if (!b) return;
    setTheme(root.getAttribute('data-ck-theme') === 'light' ? 'dark' : 'light');
  });

  /* ---------------- header state ---------------- */
  var header;
  function onScroll() {
    header = header || qs('[data-ck-header]');
    if (!header) return;
    var scrolled = window.scrollY > 0;
    header.classList.toggle('is-scrolled', scrolled);
    // at the very top the header is transparent over the hero photo, so it uses the light-on-dark text and logo
    var hero = qs('.ck-hero, .ck-about-hero');
    header.classList.toggle('ck-dark', !scrolled && !!hero);
    // sticky bars (shop filter, product gallery) sit just below the header, whatever height it wraps to
    root.style.setProperty('--ck-hdr', header.offsetHeight + 'px');
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });

  /* ---------------- anchor scroll ---------------- */
  doc.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href*="#"]');
    if (!a || e.defaultPrevented) return;
    var u;
    try {
      u = new URL(a.href, location.href);
    } catch (err) {
      return;
    }
    if (u.pathname !== location.pathname || !u.hash || u.hash === '#') return;
    var id = decodeURIComponent(u.hash.slice(1));
    var el = id === 'top' ? null : doc.getElementById(id);
    if (id !== 'top' && !el) return;
    e.preventDefault();
    window.scrollTo({
      top: el ? el.getBoundingClientRect().top + window.scrollY - (header ? header.offsetHeight : 70) + 1 : 0,
      behavior: reduce ? 'auto' : 'smooth',
    });
  });

  /* ---------------- reveal + words ---------------- */
  var io;
  function initReveal() {
    if (!fx || !('IntersectionObserver' in window)) {
      qsa('[data-reveal],[data-word]').forEach(function (el) {
        el.classList.add('is-in');
      });
      return;
    }
    io =
      io ||
      new IntersectionObserver(
        function (entries) {
          entries.forEach(function (en) {
            if (!en.isIntersecting) return;
            (en.target._ckr || [en.target]).forEach(function (el) {
              el.classList.add('is-in');
            });
            io.unobserve(en.target);
          });
        },
        { threshold: 0.12, rootMargin: '0px 0px -40px 0px' },
      );
    qsa('[data-reveal]').forEach(function (el) {
      if (!once(el, 'rv')) return;
      el.style.setProperty('--d', (+el.getAttribute('data-delay') || 0) + 'ms');
      // A clip-path:inset(..100%) element never counts as intersecting, so observe its parent instead.
      var t = el.getAttribute('data-reveal') === 'clip' && el.parentElement ? el.parentElement : el;
      if (!t._ckr) {
        t._ckr = [];
        io.observe(t);
      }
      t._ckr.push(el);
    });
    var words = qsa('[data-word]').filter(function (w) {
      return once(w, 'wd');
    });
    words.forEach(function (w, i) {
      w.style.setProperty('--d', 120 + i * 110 + 'ms');
    });
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        words.forEach(function (w) {
          w.classList.add('is-in');
        });
      });
    });
  }

  /* ---------------- scrub text ---------------- */
  var scrubs = [];
  function initScrub() {
    qsa('[data-scrub]').forEach(function (el) {
      if (!once(el, 'sc')) return;
      var words = [];
      (function walk(node) {
        Array.prototype.slice.call(node.childNodes).forEach(function (n) {
          if (n.nodeType === 3) {
            var frag = doc.createDocumentFragment();
            n.textContent.split(/(\s+)/).forEach(function (p) {
              if (!p) return;
              if (/^\s+$/.test(p)) frag.appendChild(doc.createTextNode(p));
              else {
                var s = doc.createElement('span');
                s.textContent = p;
                s.style.opacity = fx ? '.15' : '1';
                words.push(s);
                frag.appendChild(s);
              }
            });
            n.replaceWith(frag);
          } else if (n.nodeType === 1) walk(n);
        });
      })(el);
      scrubs.push({ el: el, words: words });
    });
  }

  /* ---------------- per-frame loop: parallax, zoom, scrub, magnetic ---------------- */
  var px = -999,
    py = -999,
    lastY = -1,
    force = true;
  function initPointer() {
    if (!once(window, 'ptr')) return;
    window.addEventListener(
      'pointermove',
      function (e) {
        px = e.clientX;
        py = e.clientY;
      },
      { passive: true },
    );
    root.addEventListener('pointerleave', function () {
      px = py = -999;
    });
  }
  function frame() {
    var vh = window.innerHeight,
      scY = window.scrollY;
    if (scY !== lastY || force) {
      lastY = scY;
      force = false;
      qsa('[data-parallax]').forEach(function (el) {
        var sec = el.closest('section');
        if (!sec) return;
        var r = sec.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        el.style.transform = 'translate3d(0,' + (-r.top * +el.getAttribute('data-parallax')).toFixed(1) + 'px,0)';
      });
      qsa('[data-zoom]').forEach(function (el) {
        var r = el.parentElement.getBoundingClientRect();
        el.style.transform = 'scale(' + (1.1 - 0.1 * clamp((vh - r.top) / vh, 0, 1)).toFixed(4) + ')';
      });
    }
    // scroll-scrubbed words: the progress glides toward the scroll position instead of jumping with every wheel tick,
    // and each word eases in over a wide, overlapping range so the highlight flows like a wave
    scrubs.forEach(function (s) {
      var r = s.el.getBoundingClientRect(),
        target = clamp((vh * 0.85 - r.top) / (r.height + vh * 0.3), 0, 1);
      if (s.cur === undefined) s.cur = target;
      var d = target - s.cur;
      if (d === 0) return;
      s.cur = Math.abs(d) < 0.0003 ? target : s.cur + d * 0.1;
      var n = s.words.length,
        span = 6;
      s.words.forEach(function (w, i) {
        var t = clamp((s.cur * (n + span) - i) / span, 0, 1);
        var o = (0.15 + 0.85 * t * t * (3 - 2 * t)).toFixed(3);
        if (w._o !== o) {
          w._o = o;
          w.style.opacity = o;
        }
      });
    });
    if (hoverCapable) {
      qsa('[data-magnetic]').forEach(function (el) {
        var r = el.getBoundingClientRect(),
          mx = el._mx || 0,
          my = el._my || 0;
        var L = r.left - mx,
          T = r.top - my,
          Rr = L + r.width,
          B = T + r.height;
        var ex = Math.max(L - px, 0, px - Rr),
          ey = Math.max(T - py, 0, py - B),
          d = Math.hypot(ex, ey),
          tx = 0,
          ty = 0;
        if (d < 50) {
          var s = 1 - d / 50;
          tx = (px - (L + r.width / 2)) * 0.3 * s;
          ty = (py - (T + r.height / 2)) * 0.4 * s;
        }
        tx = Math.round(tx * 10) / 10;
        ty = Math.round(ty * 10) / 10;
        if (tx !== mx || ty !== my) {
          el._mx = tx;
          el._my = ty;
          el.style.transform = tx || ty ? 'translate(' + tx + 'px,' + ty + 'px)' : '';
        }
      });
    }
    requestAnimationFrame(frame);
  }

  /* ---------------- spotlight + interlock ---------------- */
  function initSpot() {
    qsa('[data-spot]').forEach(function (el) {
      if (!once(el, 'sp')) return;
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        el.style.setProperty('--mx', e.clientX - r.left + 'px');
        el.style.setProperty('--my', e.clientY - r.top + 'px');
      });
      el.addEventListener('pointerenter', function () {
        el.style.setProperty('--o', '1');
      });
      el.addEventListener('pointerleave', function () {
        el.style.setProperty('--o', '0');
      });
    });
    qsa('[data-interlock-group]').forEach(function (g) {
      if (!once(g, 'il')) return;
      var cards = qsa('[data-interlock]', g);
      cards.forEach(function (c) {
        c.addEventListener('pointerenter', function (e) {
          if (e.pointerType === 'touch') return;
          cards.forEach(function (o) {
            var on = o === c;
            o.style.transform = on ? 'scale(1.01)' : 'scale(.98)';
            o.style.filter = on ? 'none' : 'blur(2px)';
            o.style.opacity = on ? '1' : '.7';
          });
        });
        c.addEventListener('pointerleave', function () {
          cards.forEach(function (o) {
            o.style.transform = '';
            o.style.filter = '';
            o.style.opacity = '';
          });
        });
      });
    });
  }

  /* ---------------- floating labels ---------------- */
  function initFloat() {
    qsa('[data-float]').forEach(function (box) {
      var inp = qs('input,select,textarea', box);
      if (!inp || !once(inp, 'fl')) return;
      var upd = function () {
        var focus = doc.activeElement === inp;
        box.classList.toggle('is-focus', focus);
        // date inputs always show a format hint (dd/mm/yyyy), so their label stays lifted
        box.classList.toggle('is-up', focus || !!inp.value || inp.type === 'date');
      };
      ['focus', 'blur', 'input', 'change'].forEach(function (ev) {
        inp.addEventListener(ev, upd);
      });
      upd();
    });
  }

  /* ---------------- hero player 3D tilt ---------------- */
  function initHeroTilt() {
    var player = qs('[data-hero-tilt]'),
      hero = qs('#top');
    if (!player || !hero || !once(player, 'tilt') || !fx || !fine || !hoverCapable) return;
    var raf = 0,
      next = null;
    function apply() {
      raf = 0;
      var n = next;
      player.style.transition = 'transform 0.6s cubic-bezier(0.2, 0.8, 0.2, 1)';
      player.style.transform = 'rotateX(' + n.tx + 'deg) rotateY(' + n.ty + 'deg) translateZ(8px) scale(1.005)';
      player.style.setProperty('--gx', n.gx + '%');
      player.style.setProperty('--gy', n.gy + '%');
    }
    hero.addEventListener('mousemove', function (e) {
      var r = hero.getBoundingClientRect(),
        x = (e.clientX - r.left) / r.width,
        y = (e.clientY - r.top) / r.height;
      next = {
        tx: ((0.5 - y) * 4).toFixed(2), // gentle tilt
        ty: ((x - 0.5) * 5).toFixed(2),
        gx: (x * 100).toFixed(0),
        gy: (y * 100).toFixed(0),
      };
      if (!raf) raf = requestAnimationFrame(apply); // one style write per frame, however fast the mouse moves
    });
    hero.addEventListener('mouseleave', function () {
      if (raf) cancelAnimationFrame(raf);
      raf = 0;
      player.style.transition = 'transform 0.6s cubic-bezier(0.2, 0.8, 0.2, 1)';
      player.style.transform = 'none';
      player.style.setProperty('--gx', '50%');
      player.style.setProperty('--gy', '30%');
    });
  }

  /* ---------------- FAQ ---------------- */
  doc.addEventListener('click', function (e) {
    var q = e.target.closest && e.target.closest('[data-faq-q]');
    if (!q) return;
    var item = q.closest('[data-faq-item]'),
      open = item.classList.contains('is-open');
    qsa('[data-faq-item].is-open', item.parentElement).forEach(function (o) {
      o.classList.remove('is-open');
      qs('[data-faq-q]', o).setAttribute('aria-expanded', 'false');
    });
    if (!open) {
      item.classList.add('is-open');
      q.setAttribute('aria-expanded', 'true');
    }
  });

  /* ---------------- morph submit (newsletter / contact / footer) ---------------- */
  function morphDone(btn) {
    if (!btn) return;
    btn.style.setProperty('--h', btn.offsetHeight + 'px');
    btn.classList.add('is-done');
    if (!fx) return;
    var chk = qs('[data-check]', btn);
    chk &&
      chk.animate(
        [
          { transform: 'translateY(-3px) rotate(45deg) scale(0)' },
          { transform: 'translateY(-3px) rotate(45deg) scale(1.3)', offset: 0.6 },
          { transform: 'translateY(-3px) rotate(45deg) scale(1)' },
        ],
        { duration: 480, easing: 'cubic-bezier(.2,.8,.2,1)' },
      );
    for (var k = 0; k < 2; k++) {
      var ring = doc.createElement('span');
      ring.style.cssText =
        'position:absolute;inset:0;border-radius:999px;border:2px solid #D4F52A;pointer-events:none;';
      btn.appendChild(ring);
      ring.animate(
        [
          { transform: 'scale(1)', opacity: 0.85 },
          { transform: 'scale(2.6)', opacity: 0 },
        ],
        { duration: 900, delay: k * 200, easing: 'cubic-bezier(.2,.8,.2,1)', fill: 'backwards' },
      ).onfinish = (function (r) {
        return function () {
          r.remove();
        };
      })(ring);
    }
  }

  /* ---------------- SweetAlert2 pop-up after a form is sent ---------------- */
  var swalLoading = null;
  function loadSwal() {
    if (window.Swal) return Promise.resolve(window.Swal);
    if (swalLoading) return swalLoading;
    swalLoading = new Promise(function (resolve, reject) {
      var s = doc.createElement('script');
      s.src = 'https://cdn.jsdelivr.net/npm/sweetalert2@11.14.5/dist/sweetalert2.all.min.js';
      s.async = true;
      s.onload = function () {
        resolve(window.Swal);
      };
      s.onerror = function () {
        swalLoading = null;
        reject(new Error('swal'));
      };
      doc.head.appendChild(s);
    });
    return swalLoading;
  }
  function esc(t) {
    var d = doc.createElement('div');
    d.textContent = t || '';
    return d.innerHTML;
  }
  // a pickleball drops, bounces, then bursts into the CourtKraze mark and confetti
  function courtStage(icon) {
    var colors = ['#d4f52a', '#8ecdf0', '#0b0d12', '#b0ec2f'],
      bits = '';
    for (var i = 0; i < 30; i++) {
      var a = (Math.PI * 2 * i) / 30 + Math.random() * 0.4,
        r = 70 + Math.random() * 80;
      bits +=
        '<i style="--x:' +
        Math.round(Math.cos(a) * r) +
        'px;--y:' +
        Math.round(Math.sin(a) * r - 20) +
        'px;--r:' +
        Math.round(Math.random() * 720 - 360) +
        'deg;--d:' +
        (Math.random() * 0.15).toFixed(2) +
        's;background:' +
        colors[i % colors.length] +
        ';' +
        (i % 3 === 0 ? 'border-radius:50%;' : '') +
        '"></i>';
    }
    var holes = '';
    [
      [22, 22],
      [42, 20],
      [32, 34],
      [18, 42],
      [46, 40],
      [32, 50],
      [30, 12],
    ].forEach(function (h) {
      holes += '<circle cx="' + h[0] + '" cy="' + h[1] + '" r="3.2" fill="#08090c" fill-opacity=".55"/>';
    });
    return (
      '<div class="ck-swal-stage" aria-hidden="true">' +
      '<span class="ck-swal-court"></span><span class="ck-swal-shadow"></span>' +
      '<span class="ck-swal-ball"><svg viewBox="0 0 64 64" width="56" height="56"><circle cx="32" cy="32" r="30" fill="#d4f52a"/>' +
      '<circle cx="32" cy="32" r="30" fill="none" stroke="#9fd000" stroke-width="2"/>' +
      holes +
      '</svg></span>' +
      '<span class="ck-swal-ring"></span><span class="ck-swal-ring ck-swal-ring--2"></span>' +
      '<img class="ck-swal-icon" src="' +
      esc(icon) +
      '" alt="" width="96" height="96">' +
      '<span class="ck-swal-bits">' +
      bits +
      '</span></div>'
    );
  }
  function ckAlert(kind, title, text) {
    var cfg = (window.ckConfig && ckConfig.popup) || {};
    return loadSwal()
      .then(function (Swal) {
        var ok = kind === 'success';
        Swal.fire({
          html:
            (ok ? courtStage(cfg.icon) : '<div class="ck-swal-oob" aria-hidden="true">!</div>') +
            '<h2 class="ck-swal__title"><mark>' +
            esc(ok ? title : cfg.errorTitle || title) +
            '</mark></h2>' +
            ((ok ? text : cfg.errorText || text)
              ? '<p class="ck-swal__text">' + esc(ok ? text : cfg.errorText || text) + '</p>'
              : ''),
          showConfirmButton: true,
          confirmButtonText: cfg.button || 'BACK TO THE GAME',
          buttonsStyling: false,
          heightAuto: false,
          timer: ok && cfg.seconds > 0 ? cfg.seconds * 1000 : undefined,
          timerProgressBar: ok && cfg.seconds > 0,
          backdrop: 'rgba(4,5,7,.62)',
          showClass: { popup: 'ck-swal-in' },
          hideClass: { popup: 'ck-swal-out' },
          customClass: {
            popup: 'ck-swal' + (ok ? '' : ' ck-swal--error'),
            confirmButton: 'ck-swal__btn',
            timerProgressBar: 'ck-swal__bar',
          },
        });
      })
      .catch(function () {
        /* offline / blocked: the inline message in the form is already showing */
      });
  }

  window.ckAlert = ckAlert; // ckAlert('success' | 'error', title, text): also usable from apps and custom sections

  /* success state of ONE form: always looked up inside that form's own wrapper, never in the whole document */
  function formSentEl(form) {
    var wrap = form.closest('[data-ck-form-wrap]') || form.parentElement;
    return qs(form.getAttribute('data-ok') || '[data-ck-ok]', wrap);
  }
  function formSentText(form) {
    var okEl = formSentEl(form),
      t = okEl && (qs('.ck-title', okEl) || okEl),
      p = okEl && qs('p', okEl);
    return { title: t ? t.textContent.trim() : '', text: p ? p.textContent.trim() : '' };
  }
  function formSentShow(form) {
    var okEl = formSentEl(form);
    form.hidden = true;
    if (okEl) okEl.hidden = false;
  }

  doc.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('[data-ck-ajax-form]');
    if (!form || e.defaultPrevented) return;
    e.preventDefault();
    if (form._busy) return;
    form._busy = true;
    var btn = qs('[data-morph-btn]', form);
    var started = Date.now();
    fetch(form.action, {
      method: 'POST',
      // urlencoded, exactly like a native <form> post (Shopify's /contact and /account endpoints expect it)
      body: new URLSearchParams(new FormData(form)),
      headers: { Accept: 'text/html' },
      credentials: 'same-origin',
    })
      .then(function (res) {
        // Shopify bot-protection redirects to /challenge — hand over to a native submit
        if (res.url && res.url.indexOf('/challenge') > -1) {
          HTMLFormElement.prototype.submit.call(form);
          return null;
        }
        if (!res.ok) throw new Error('bad status');
        // Shopify redirects (302 -> ?contact_posted=true / ?customer_posted=true) on success. A plain 200 means the
        // form was re-rendered, so look for the server-side error marker instead of assuming success.
        if (res.redirected) return true;
        return res.text().then(function (html) {
          if (html.indexOf('data-ck-form-error') > -1) throw new Error('validation');
          return true;
        });
      })
      .then(function (ok) {
        if (!ok) return;
        morphDone(btn);
        // the pop-up comes right away; the in-card success message follows once the button's tick has played
        var msg = formSentText(form);
        setTimeout(
          function () {
            ckAlert('success', msg.title, msg.text);
          },
          fx ? 350 : 0,
        );
        setTimeout(
          function () {
            formSentShow(form);
          },
          fx ? Math.max(1200, 1600 - (Date.now() - started)) : 300,
        );
      })
      .catch(function () {
        form._busy = false;
        var err = qs('[data-ck-err]', form.closest('[data-ck-form-wrap]') || form.parentElement);
        if (err) err.hidden = false;
        ckAlert('error', '', err ? err.textContent.trim() : '');
      });
  });

  /* ---------------- featured product (tilt, swatches, thumbs) ---------------- */
  function morphFlash(scope) {
    if (!fx) return;
    qsa('[data-morph]', scope).forEach(function (el) {
      el.animate(
        [
          { opacity: 0, scale: '.88', filter: 'blur(8px)' },
          { opacity: 1, scale: '1', filter: 'blur(0px)' },
        ],
        { duration: 380, easing: 'cubic-bezier(.2,.8,.2,1)' },
      );
    });
  }
  function initFeatured() {
    qsa('[data-ck-feat]').forEach(function (sec) {
      if (!once(sec, 'feat')) return;
      var stage = qs('[data-tilt]', sec),
        light = function () {
          return root.getAttribute('data-ck-theme') === 'light';
        };
      var swatches = qsa('[data-swatch]', sec),
        thumbs = qsa('[data-thumb]', sec);
      thumbs.forEach(function (t) {
        t.dataset.orig = t.dataset.media || '';
        var ti = qs('img', t);
        if (ti) {
          ti.dataset.origSrc = ti.getAttribute('src') || '';
          ti.dataset.origSrcset = ti.getAttribute('srcset') || '';
          ti.dataset.origHidden = ti.hidden ? '1' : '0';
        }
      });
      var state = {
        color: Math.max(
          0,
          swatches.findIndex(function (s) {
            return s.classList.contains('is-on');
          }),
        ),
        thumb: 0,
        glow: '120,130,150',
      };
      sec._ck = state;

      // Show only the chosen colour's product images (tagged by alt text or the variant's image; untagged are shared)
      function filterThumbs(sw) {
        var want = (sw.dataset.name || '').toLowerCase(),
          box = qs('[data-thumbs]', sec),
          shown = 0;
        thumbs.forEach(function (t) {
          var cs = (t.dataset.colors || '').toLowerCase().split('||').filter(Boolean);
          t._show = !cs.length || cs.indexOf(want) > -1;
        });
        if (
          !thumbs.some(function (t) {
            return t._show;
          })
        )
          thumbs.forEach(function (t) {
            t._show = true;
          });
        // at most 6 thumbnails for the chosen colour
        thumbs.forEach(function (t) {
          if (t._show && shown >= 6) t._show = false;
          else if (t._show) shown++;
          t.style.display = t._show ? '' : 'none';
        });
        if (box) box.style.setProperty('--n', Math.max(1, Math.min(6, shown)));
        var cur = thumbs[state.thumb];
        if (state.thumb < 0 || !cur || !cur._show) {
          var pick = -1;
          thumbs.forEach(function (t, i) {
            if (pick < 0 && t._show && sw.dataset.media && t.dataset.orig === sw.dataset.media) pick = i;
          });
          if (pick < 0)
            pick = thumbs.findIndex(function (t) {
              return t._show;
            });
          state.thumb = Math.max(0, pick);
          thumbs.forEach(function (o, j) {
            o.classList.toggle('is-on', j === state.thumb);
            o.setAttribute('aria-pressed', j === state.thumb);
          });
        }
      }

      function paint() {
        var sw = swatches[state.color];
        if (!sw) return;
        filterThumbs(sw);
        var tint = light() ? sw.dataset.tintLight : sw.dataset.tint,
          label = light() ? sw.dataset.labelLight : sw.dataset.label;
        sec.style.setProperty('--tint', tint);
        sec.style.setProperty('--label', label);
        state.glow = sw.dataset.glow;
        qsa('[data-color-name]', sec).forEach(function (el) {
          el.textContent = sw.dataset.name;
        });
        // price follows the chosen colour's variant
        var pr = qs('[data-feat-price]', sec),
          cm = qs('[data-feat-compare]', sec),
          sv = qs('[data-feat-save]', sec);
        if (pr && sw.dataset.price) {
          pr.textContent = sw.dataset.price;
          if (cm) {
            cm.hidden = !sw.dataset.compare;
            cm.textContent = sw.dataset.compare || '';
          }
          if (sv) {
            sv.hidden = !sw.dataset.save;
            sv.textContent = sw.dataset.save ? sw.dataset.save + '% OFF' : '';
          }
        }
        var view = thumbs[state.thumb] ? thumbs[state.thumb].dataset.view : '';
        var ph = qs('[data-shot-label]', sec);
        if (ph)
          ph.textContent =
            '[ product shot — ' +
            (sec.dataset.title || 'product').toLowerCase() +
            ', ' +
            sw.dataset.name.toLowerCase() +
            ', ' +
            view.toLowerCase() +
            ' ]';
        // Bundled colour gallery (4 views) wins when the swatch has one; otherwise the product's own media.
        var gal = sw.dataset.gallery ? sw.dataset.gallery.split('|') : null,
          galSm = sw.dataset.gallerySm ? sw.dataset.gallerySm.split('|') : null;
        thumbs.forEach(function (t, i) {
          var ti = qs('img', t);
          if (!ti) return;
          if (gal) {
            t.dataset.media = gal[i] || '';
            // Shopify's image_tag emits srcset, which would win over src — drop it while a bundled photo is shown
            ti.removeAttribute('srcset');
            ti.removeAttribute('sizes');
            ti.src = (galSm && galSm[i]) || gal[i] || ti.src;
            ti.hidden = false;
          } else {
            t.dataset.media = t.dataset.orig || '';
            ti.src = ti.dataset.origSrc;
            if (ti.dataset.origSrcset) ti.setAttribute('srcset', ti.dataset.origSrcset);
            ti.hidden = ti.dataset.origHidden === '1';
          }
        });
        var img = qs('[data-shot-img]', sec),
          src = (gal && gal[state.thumb]) || (thumbs[state.thumb] && thumbs[state.thumb].dataset.media) || '';
        if (img) {
          if (src) {
            img.src = src;
            img.hidden = false;
          } else img.hidden = true;
        }
        if (ph) ph.hidden = !!src;
        if (gal)
          gal.forEach(function (u) {
            new Image().src = u; // warm the cache so thumbnail clicks swap instantly
          });
        var tilt = stage && stage._lastShadow;
        if (tilt === undefined && stage) shadow(0, 0, false);
        doc.dispatchEvent(new CustomEvent('ck:color', { detail: { index: state.color, swatch: sw.dataset } }));
      }
      function shadow(tx, ty, hov) {
        if (!stage) return;
        var a = hov ? (light() ? 0.45 : 0.4) : light() ? 0.22 : 0.16;
        stage.style.boxShadow =
          (-ty * 2.2).toFixed(1) +
          'px ' +
          (tx * 2.2 + 34).toFixed(1) +
          'px 90px -18px rgba(' +
          state.glow +
          ',' +
          a +
          ')';
        stage._lastShadow = true;
      }
      swatches.forEach(function (s, i) {
        s.addEventListener('click', function () {
          if (i === state.color || s.disabled) return;
          swatches.forEach(function (o, j) {
            o.classList.toggle('is-on', j === i);
            o.setAttribute('aria-pressed', j === i);
          });
          state.color = i;
          state.thumb = -1; // start on this colour's first image
          paint();
          // every link on the featured card opens the product page on the chosen colour
          var vid = swatches[i].dataset.variant;
          if (vid)
            qsa('[data-feat-link]', sec).forEach(function (l) {
              l.href = l.href.split('?')[0] + '?variant=' + vid;
            });
        });
      });
      thumbs.forEach(function (t, i) {
        t.addEventListener('click', function () {
          if (i === state.thumb) return;
          thumbs.forEach(function (o, j) {
            o.classList.toggle('is-on', j === i);
            o.setAttribute('aria-pressed', j === i);
          });
          state.thumb = i;
          paint();
        });
      });
      if (stage && fx && hoverCapable) {
        stage.addEventListener('mousemove', function (e) {
          var r = stage.getBoundingClientRect(),
            x = (e.clientX - r.left) / r.width,
            y = (e.clientY - r.top) / r.height;
          stage.style.setProperty('--gx', (x * 100).toFixed(0) + '%');
          stage.style.setProperty('--gy', (y * 100).toFixed(0) + '%');
          shadow(0, 0, true);
        });
        stage.addEventListener('mouseleave', function () {
          stage.style.setProperty('--gx', '50%');
          stage.style.setProperty('--gy', '30%');
          shadow(0, 0, false);
        });
      }
      new MutationObserver(paint).observe(root, { attributes: true, attributeFilter: ['data-ck-theme'] });
      paint();
    });
  }

  /* ---------------- cart: badge, bag + quick-add drawer, global AJAX hooks ---------------- */
  var drawer,
    closing = false,
    lastCart = null;
  var routesCart = function (p) {
    return ((window.routes && routes.cart_url) || '/cart') + p;
  };
  function money(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }
  function bump(n, animate) {
    qsa('[data-cart-badge]').forEach(function (b) {
      b.textContent = n;
      b.hidden = !(n > 0); // no badge on an empty bag
      if (animate && fx)
        b.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.5)' }, { transform: 'scale(1)' }], {
          duration: 500,
          easing: 'cubic-bezier(.34,1.56,.64,1)',
        });
    });
  }
  // One cart event contract for the whole theme (and any app/section that wants to join in):
  //   document.dispatchEvent(new CustomEvent('cart:refresh'))                       -> we re-fetch /cart.js and update the badge
  //   document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } })) -> we adopt that cart's item_count
  // We announce our own changes with cart:updated { detail: { cart, source: 'courtkraze' } }.
  function emitCart(cart) {
    doc.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart, source: 'courtkraze' } }));
  }
  doc.addEventListener('cart:refresh', function () {
    refreshCount(true);
  });
  doc.addEventListener('cart:updated', function (e) {
    var d = e.detail || {};
    if (d.source === 'courtkraze') return; // our own broadcast
    if (d.cart && typeof d.cart.item_count === 'number') {
      lastCart = d.cart;
      bump(d.cart.item_count, true);
      if (drawer && !drawer.hidden) renderBag(d.cart);
    } else refreshCount(true);
  });
  function refreshCount(animate) {
    return fetch(routesCart('.js'), { headers: { Accept: 'application/json', 'X-CK': '1' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (c) {
        lastCart = c;
        bump(c.item_count, animate);
        if (drawer && !drawer.hidden) renderBag(c);
        emitCart(c);
        return c;
      })
      .catch(function () {
        return null;
      });
  }
  function currentFeature() {
    var sec = qs('[data-ck-feat]');
    return sec && sec._ck ? { sec: sec, st: sec._ck, sw: qsa('[data-swatch]', sec)[sec._ck.color] } : null;
  }
  function view(mode) {
    drawer._s.mode = mode;
    qs('[data-d-add-view]', drawer).hidden = mode !== 'add';
    qs('[data-d-bag-view]', drawer).hidden = mode !== 'bag';
    qs('[data-d-heading]', drawer).textContent = mode === 'add' ? 'QUICK ADD' : 'YOUR BAG';
  }
  function syncQuickAdd() {
    var f = currentFeature(),
      s = drawer._s;
    var has = !!f && !!f.sw;
    qs('[data-d-product]', drawer).hidden = !has;
    qs('[data-d-empty]', drawer).hidden = has;
    if (!has) return;
    var light = root.getAttribute('data-ck-theme') === 'light',
      sw = f.sw;
    qs('[data-d-visual]', drawer).style.background = light ? sw.dataset.tintLight : sw.dataset.tint;
    var lab = qs('[data-d-label]', drawer);
    lab.style.color = light ? sw.dataset.labelLight : sw.dataset.label;
    var img = qs('[data-d-img]', drawer);
    if (sw.dataset.media) {
      img.src = sw.dataset.media;
      img.hidden = false;
      lab.textContent = '';
    } else {
      img.hidden = true;
      lab.textContent =
        '[ ' + (f.sec.dataset.title || 'product').toLowerCase() + ' — ' + sw.dataset.name.toLowerCase() + ' ]';
    }
    qs('[data-d-title]', drawer).textContent = f.sec.dataset.title || '';
    qs('[data-d-price]', drawer).textContent = sw.dataset.price || '';
    var box = qs('[data-d-swatches]', drawer);
    box.innerHTML = '';
    qsa('[data-swatch]', f.sec).forEach(function (o, i) {
      var b = doc.createElement('button');
      b.type = 'button';
      b.className = 'ck-swatch' + (i === f.st.color ? ' is-on' : '');
      b.style.cssText = 'padding:8px 14px 8px 8px;font-size:11px;gap:8px;min-height:44px;';
      b.disabled = o.disabled;
      var dot = doc.createElement('span');
      dot.className = 'ck-swatch__dot';
      dot.style.cssText = 'width:22px;height:22px;background:' + o.dataset.hex;
      b.appendChild(dot);
      b.appendChild(doc.createTextNode(o.dataset.name));
      b.addEventListener('click', function () {
        o.click();
        syncQuickAdd();
        morphFlash(drawer);
      });
      box.appendChild(b);
    });
    qs('[data-d-qty]', drawer).textContent = s.qty;
    qs('[data-d-add]', drawer).disabled = !sw.dataset.variant;
  }
  function renderBag(cart) {
    var list = qs('[data-b-lines]', drawer);
    list.innerHTML = '';
    var empty = !cart || !cart.items.length;
    qs('[data-b-empty]', drawer).hidden = !empty;
    qs('[data-b-foot]', drawer).hidden = empty;
    if (empty) return;
    cart.items.forEach(function (it, i) {
      var li = doc.createElement('li');
      li.className = 'ck-bagline';
      var im = doc.createElement('div');
      im.className = 'ck-bagline__img';
      if (it.image) {
        var img = doc.createElement('img');
        img.src = it.image.replace(/(\.[a-z]+)(\?|$)/i, '_240x$1$2');
        img.alt = (it.featured_image && it.featured_image.alt) || '';
        img.width = 80;
        img.height = 80;
        img.loading = 'lazy';
        im.appendChild(img);
      }
      var info = doc.createElement('div');
      info.className = 'ck-bagline__info';
      var t = doc.createElement('a');
      t.href = it.url;
      t.textContent = it.product_title;
      t.className = 'ck-bagline__title';
      info.appendChild(t);
      if (it.variant_title) {
        var v = doc.createElement('div');
        v.className = 'ck-mono';
        v.style.cssText = 'font-size:11px;color:var(--ck-muted2);';
        v.textContent = it.variant_title;
        info.appendChild(v);
      }
      var pr = doc.createElement('div');
      pr.className = 'ck-mono';
      pr.style.cssText = 'font-size:12px;color:var(--ck-sky);';
      pr.textContent = money(it.final_line_price);
      info.appendChild(pr);
      var q = doc.createElement('div');
      q.className = 'ck-qty ck-qty--sm';
      var mk = function (txt, label, qty) {
        var b = doc.createElement('button');
        b.type = 'button';
        b.textContent = txt;
        b.setAttribute('aria-label', label);
        b.addEventListener('click', function () {
          changeLine(i + 1, qty);
        });
        return b;
      };
      var out = doc.createElement('output');
      out.textContent = it.quantity;
      q.appendChild(mk('−', 'Decrease quantity', it.quantity - 1));
      q.appendChild(out);
      q.appendChild(mk('+', 'Increase quantity', it.quantity + 1));
      var rm = doc.createElement('button');
      rm.type = 'button';
      rm.className = 'ck-bagline__rm';
      rm.textContent = 'REMOVE';
      rm.addEventListener('click', function () {
        changeLine(i + 1, 0);
      });
      var row = doc.createElement('div');
      row.style.cssText = 'display:flex;align-items:center;justify-content:space-between;gap:8px;margin-top:6px;';
      row.appendChild(q);
      row.appendChild(rm);
      info.appendChild(row);
      li.appendChild(im);
      li.appendChild(info);
      list.appendChild(li);
    });
    qs('[data-b-sub]', drawer).textContent = money(cart.total_price);
  }
  function changeLine(line, quantity) {
    fetch(routesCart('/change.js').replace('/cart/change.js', '/cart/change.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-CK': '1' },
      body: JSON.stringify({ line: line, quantity: quantity }),
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (c) {
        if (c.items) {
          lastCart = c;
          bump(c.item_count, false);
          renderBag(c);
          emitCart(c);
        }
      })
      .catch(function () {});
  }
  function openDrawer(mode) {
    drawer = drawer || qs('[data-ck-drawer]');
    if (!drawer) return;
    drawer._s = drawer._s || { qty: 1, mode: 'bag' };
    var wasOpen = !drawer.hidden;
    if (mode === 'add' && !currentFeature()) mode = 'bag';
    if (mode === 'add') {
      drawer._s.qty = 1;
      qs('[data-d-msg]', drawer).hidden = true;
      syncQuickAdd();
    }
    view(mode);
    if (mode === 'bag') {
      renderBag(lastCart);
      refreshCount(false);
    }
    if (wasOpen) return;
    drawer.hidden = false;
    drawer._opener = doc.activeElement;
    doc.body.style.overflow = 'hidden';
    var aside = qs('[data-d-aside]', drawer),
      bg = qs('[data-d-bg]', drawer);
    qs('[data-d-close]', drawer).focus({ preventScroll: true });
    if (!fx) return;
    bg.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 320, easing: 'ease-out' });
    aside.animate(
      [
        { transform: 'translateX(100%)' },
        { transform: 'translateX(-2%)', offset: 0.62 },
        { transform: 'translateX(.6%)', offset: 0.82 },
        { transform: 'translateX(0)' },
      ],
      { duration: 760, easing: 'cubic-bezier(.22,1,.36,1)' },
    );
    qsa('[data-stagger]', aside).forEach(function (el, i) {
      el.animate(
        [
          { opacity: 0, transform: 'translateY(22px)' },
          { opacity: 1, transform: 'none' },
        ],
        { duration: 560, delay: 200 + i * 70, easing: 'cubic-bezier(.2,.8,.2,1)', fill: 'backwards' },
      );
    });
  }
  function closeDrawer() {
    if (!drawer || drawer.hidden || closing) return;
    var finish = function () {
      closing = false;
      drawer.hidden = true;
      doc.body.style.overflow = '';
      // fill:'forwards' would otherwise pin the drawer off-screen on the next open
      drawer.getAnimations({ subtree: true }).forEach(function (an) {
        an.cancel();
      });
      if (drawer._opener && drawer._opener.focus) drawer._opener.focus({ preventScroll: true });
    };
    if (!fx) return finish();
    closing = true;
    qs('[data-d-bg]', drawer).animate([{ opacity: 1 }, { opacity: 0 }], { duration: 320, fill: 'forwards' });
    qs('[data-d-aside]', drawer).animate([{ transform: 'translateX(0)' }, { transform: 'translateX(100%)' }], {
      duration: 340,
      easing: 'cubic-bezier(.55,0,.8,.2)',
      fill: 'forwards',
    }).onfinish = finish;
  }
  function showAdded(text) {
    openDrawer('bag');
    var m = qs('[data-b-msg]', drawer);
    if (text) {
      m.textContent = text;
      m.hidden = false;
    } else m.hidden = true;
  }
  function addToBag() {
    var f = currentFeature();
    if (!f || !f.sw.dataset.variant) return;
    var btn = qs('[data-d-add]', drawer),
      msg = qs('[data-d-msg]', drawer),
      qty = drawer._s.qty,
      name = f.sw.dataset.name;
    btn.disabled = true;
    fetch(((window.routes && routes.cart_add_url) || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-CK': '1' },
      body: JSON.stringify({ items: [{ id: +f.sw.dataset.variant, quantity: qty }] }),
    })
      .then(function (r) {
        return r.json().then(function (j) {
          return { ok: r.ok, j: j };
        });
      })
      .then(function (res) {
        if (!res.ok) {
          msg.hidden = false;
          msg.dataset.state = 'error';
          msg.textContent = res.j.description || res.j.message || 'Could not add to bag.';
          return;
        }
        return refreshCount(true).then(function () {
          showAdded('Added ' + qty + ' × ' + name + ' to your bag.');
        });
      })
      .catch(function () {
        msg.hidden = false;
        msg.dataset.state = 'error';
        msg.textContent = 'Something went wrong. Please try again.';
      })
      .then(function () {
        btn.disabled = false;
      });
  }
  doc.addEventListener('click', function (e) {
    var t =
      e.target.closest &&
      e.target.closest(
        '[data-ck-open-drawer],[data-d-close],[data-d-bg],[data-d-dec],[data-d-inc],[data-d-add],[data-ck-drawer] a[href]',
      );
    if (!t) return;
    // any link inside the drawer (e.g. SHOP ALL) closes it, then the browser follows the link as usual
    if (t.tagName === 'A') return closeDrawer();
    if (t.hasAttribute('data-ck-open-drawer')) {
      e.preventDefault();
      return openDrawer(t.getAttribute('data-ck-open-drawer') || 'bag');
    }
    if (t.hasAttribute('data-d-close') || t.hasAttribute('data-d-bg')) return closeDrawer();
    if (t.hasAttribute('data-d-dec')) {
      drawer._s.qty = Math.max(1, drawer._s.qty - 1);
      qs('[data-d-qty]', drawer).textContent = drawer._s.qty;
      return;
    }
    if (t.hasAttribute('data-d-inc')) {
      drawer._s.qty = Math.min(20, drawer._s.qty + 1);
      qs('[data-d-qty]', drawer).textContent = drawer._s.qty;
      return;
    }
    if (t.hasAttribute('data-d-add')) return addToBag();
  });
  doc.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') return closeDrawer();
    if (e.key !== 'Tab' || !drawer || drawer.hidden) return;
    var f = qsa('a[href],button:not([disabled]),input,select', qs('[data-d-aside]', drawer)).filter(function (x) {
      return x.offsetParent !== null;
    });
    if (!f.length) return;
    if (e.shiftKey && doc.activeElement === f[0]) {
      e.preventDefault();
      f[f.length - 1].focus();
    } else if (!e.shiftKey && doc.activeElement === f[f.length - 1]) {
      e.preventDefault();
      f[0].focus();
    }
  });
  doc.addEventListener('ck:color', function () {
    if (drawer && !drawer.hidden && drawer._s.mode === 'add') syncQuickAdd();
  });

  // Bridge: Dawn's product-form looks up <cart-drawer> and calls these three methods after add-to-cart.
  if (!customElements.get('cart-drawer')) {
    customElements.define(
      'cart-drawer',
      class extends HTMLElement {
        getSectionsToRender() {
          return [{ id: 'cart-icon-bubble' }];
        }
        setActiveElement() {}
        renderContents() {
          refreshCount(true).then(function () {
            showAdded();
          });
        }
      },
    );
  }
  // Any other add/change/update (quick-add modals, cart page, apps) keeps the badge in sync; adds open the drawer.
  var nativeFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = nativeFetch.apply(this, arguments);
    var own = init && init.headers && init.headers['X-CK'];
    if (!own && /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) {
      var isAdd = /\/cart\/add/.test(url);
      p.then(function (res) {
        if (res.ok)
          refreshCount(isAdd).then(function () {
            if (isAdd && !(drawer && !drawer.hidden)) showAdded();
          });
      }).catch(function () {});
    }
    return p;
  };

  /* ---------------- shop: cards, product page, waitlist ---------------- */
  function postAdd(id, qty) {
    // not tagged X-CK on purpose: the fetch wrapper below then refreshes the badge and opens the bag drawer
    return fetch(((window.routes && routes.cart_add_url) || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: +id, quantity: qty || 1 }] }),
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart.');
        return j;
      });
    });
  }
  function flashDone(btn) {
    morphDone(btn);
    setTimeout(function () {
      btn.classList.remove('is-done');
      btn.disabled = false;
    }, 1900);
  }

  function initCards() {
    qsa('[data-ck-pcard]').forEach(function (card) {
      if (!once(card, 'pc')) return;
      var img = qs('[data-pcard-img]', card),
        price = qs('[data-pcard-price]', card),
        add = qs('[data-pcard-add]', card),
        dots = qsa('[data-dot]', card);
      dots.forEach(function (d) {
        d.addEventListener('click', function () {
          dots.forEach(function (o) {
            o.classList.toggle('is-on', o === d);
            o.setAttribute('aria-pressed', o === d);
          });
          if (img && d.dataset.img) {
            img.src = d.dataset.img;
            if (fx) img.animate([{ opacity: 0.2 }, { opacity: 1 }], { duration: 380, easing: 'ease-out' });
          }
          if (price) price.innerHTML = (d.dataset.compare ? '<s>' + d.dataset.compare + '</s> ' : '') + d.dataset.price;
          // every link on the card now opens the product page on the chosen colour
          qsa('a[href]', card).forEach(function (a) {
            a.href = a.href.split('?')[0] + '?variant=' + d.dataset.variant;
          });
          if (add) {
            add.dataset.variant = d.dataset.variant;
            add.disabled = d.dataset.available === 'false';
            qs('.ck-morph__txt', add).textContent = add.disabled ? 'SOLD OUT' : 'ADD TO BAG';
          }
        });
      });
      if (add)
        add.addEventListener('click', function () {
          if (add.disabled || add.classList.contains('is-done')) return;
          add.disabled = true;
          postAdd(add.dataset.variant, 1)
            .then(function () {
              flashDone(add);
            })
            .catch(function () {
              add.disabled = false;
            });
        });
    });
  }

  function initPdp() {
    qsa('[data-ck-pdp]').forEach(function (root) {
      if (!once(root, 'pdp')) return;
      var dataEl = qs('[data-pdp-json]', root);
      if (!dataEl) return;
      var data;
      try {
        data = JSON.parse(dataEl.textContent);
      } catch (e) {
        return;
      }
      var form = qs('[data-ck-pdp-form]', root),
        idInput = qs('input[name="id"]', form),
        stage = qs('[data-pdp-stage]', root),
        img = qs('[data-pdp-img]', root),
        thumbsBox = qs('[data-pdp-thumbs]', root),
        qty = qs('[data-pdp-qty]', root),
        addBtn = qs('[data-pdp-add]', root),
        msg = qs('[data-pdp-msg]', root),
        buyBtn = qs('[data-pdp-buy]', root),
        gal = null,
        galKey = '',
        cur = 0;

      function flash() {
        if (fx && img)
          img.animate(
            [
              { opacity: 0.15, scale: '1.03' },
              { opacity: 1, scale: '1' },
            ],
            { duration: 420, easing: 'cubic-bezier(.2,.8,.2,1)' },
          );
      }
      function show(i) {
        if (!gal || !gal.big.length) return;
        cur = Math.max(0, Math.min(gal.big.length - 1, i));
        if (img) {
          img.src = gal.big[cur];
          img.hidden = false;
        }
        qsa('[data-pdp-thumb]', root).forEach(function (t, j) {
          t.classList.toggle('is-on', j === cur);
          t.setAttribute('aria-pressed', j === cur);
        });
        flash();
      }
      function setGallery(key, g, start) {
        if (!g || !g.big.length) return;
        if (key !== galKey) {
          gal = g;
          galKey = key;
          thumbsBox.innerHTML = '';
          g.big.forEach(function (u, i) {
            var b = doc.createElement('button');
            b.type = 'button';
            b.className = 'ck-pdp__thumb';
            b.setAttribute('data-pdp-thumb', '');
            b.setAttribute('aria-label', 'Photo ' + (i + 1));
            var im = doc.createElement('img');
            im.src = (g.small && g.small[i]) || u;
            im.alt = '';
            im.width = 160;
            im.height = 160;
            im.loading = 'lazy';
            b.appendChild(im);
            b.addEventListener('click', function () {
              show(i);
            });
            thumbsBox.appendChild(b);
          });
          g.big.forEach(function (u) {
            new Image().src = u;
          });
        }
        show(start || 0);
      }
      // the product's own images for the chosen colour: those tagged with the colour (alt text or the variant's image)
      // plus any untagged (shared) ones. Falls back to every image when nothing matches.
      function productGallery(colour) {
        var p = data.product,
          want = (colour || '').toLowerCase(),
          idx = [];
        p.big.forEach(function (u, i) {
          var cs = ((p.colors && p.colors[i]) || '').toLowerCase().split('||').filter(Boolean);
          if (!cs.length || cs.indexOf(want) > -1) idx.push(i);
        });
        if (!idx.length || !want)
          idx = p.big.map(function (u, i) {
            return i;
          });
        return {
          idx: idx,
          big: idx.map(function (i) {
            return p.big[i];
          }),
          small: idx.map(function (i) {
            return p.small[i];
          }),
        };
      }
      // thumbnails rendered by the server need their click handlers too
      var initial = qsa('[data-pdp-thumb]', root);
      var initialBig = initial.map(function (t) {
        return t.getAttribute('data-src');
      });
      gal = { big: initialBig, small: [] };
      galKey = '__server';
      initial.forEach(function (t, i) {
        t.addEventListener('click', function () {
          show(i);
        });
      });

      function chosen() {
        return qsa('[data-pdp-option]', root).map(function (fs) {
          var c = qs('input:checked', fs);
          return c ? c.value : '';
        });
      }
      function findVariant(opts) {
        for (var i = 0; i < data.variants.length; i++) {
          var v = data.variants[i],
            okAll = true;
          for (var j = 0; j < opts.length; j++) if (v.options[j] !== opts[j]) okAll = false;
          if (okAll) return v;
        }
        return null;
      }
      function apply(v, fromUser) {
        qsa('[data-pdp-option]', root).forEach(function (fs) {
          var c = qs('input:checked', fs),
            lab = qs('[data-pdp-option-value]', fs);
          if (c && lab) lab.textContent = c.value.toUpperCase();
        });
        if (!v) {
          addBtn.disabled = true;
          qs('[data-pdp-add-label]', root).textContent = data.labels.soldOut;
          return;
        }
        idInput.value = v.id;
        qs('[data-pdp-price]', root).textContent = v.price;
        var cmp = qs('[data-pdp-compare]', root),
          sv = qs('[data-pdp-save]', root);
        cmp.hidden = !v.compare;
        cmp.textContent = v.compare;
        sv.hidden = !v.save;
        sv.textContent = v.save ? v.save + '% OFF' : '';
        addBtn.disabled = !v.available;
        if (buyBtn) buyBtn.disabled = !v.available;
        qs('[data-pdp-add-label]', root).textContent = v.available ? data.labels.add : data.labels.soldOut;
        msg.hidden = true;
        // gallery: bundled colour photos when the colour is recognised, otherwise the product's own media
        var colour = data.colorPos > 0 ? v.options[data.colorPos - 1] : '',
          key,
          g,
          start = 0;
        if (data.bundled && v.photo) {
          key = v.photo;
          g = data.galleries[v.photo];
        } else {
          key = 'product:' + colour;
          g = productGallery(colour);
          if (v.imageIndex > -1) start = Math.max(0, g.idx.indexOf(v.imageIndex));
        }
        if (fromUser || key !== galKey) setGallery(key, g, start);
        if (fromUser && window.history && history.replaceState) {
          var u = new URL(location.href);
          u.searchParams.set('variant', v.id);
          history.replaceState(null, '', u.toString());
        }
      }
      qsa('[data-pdp-option] input', root).forEach(function (inp) {
        inp.addEventListener('change', function () {
          apply(findVariant(chosen()), true);
        });
      });

      var dec = qs('[data-pdp-dec]', root),
        inc = qs('[data-pdp-inc]', root);
      dec.addEventListener('click', function () {
        qty.value = Math.max(1, (+qty.value || 1) - 1);
      });
      inc.addEventListener('click', function () {
        qty.value = Math.min(20, (+qty.value || 1) + 1);
      });

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (addBtn.disabled || addBtn.classList.contains('is-done')) return;
        addBtn.disabled = true;
        msg.hidden = true;
        postAdd(idInput.value, +qty.value || 1)
          .then(function () {
            flashDone(addBtn);
          })
          .catch(function (err) {
            addBtn.disabled = false;
            msg.hidden = false;
            msg.setAttribute('data-state', 'error');
            msg.textContent = err.message || data.labels.error || 'Could not add to cart.';
          });
      });

      // "Buy it now": add, then go straight to checkout
      if (buyBtn)
        buyBtn.addEventListener('click', function () {
          if (buyBtn.disabled) return;
          buyBtn.disabled = true;
          msg.hidden = true;
          postAdd(idInput.value, +qty.value || 1)
            .then(function () {
              location.href = '/checkout';
            })
            .catch(function (err) {
              buyBtn.disabled = false;
              msg.hidden = false;
              msg.setAttribute('data-state', 'error');
              msg.textContent = err.message || data.labels.error || 'Could not add to cart.';
            });
        });

      // colourway cards further down the page pick the matching colour here
      qsa('[data-pick-color]').forEach(function (card) {
        card.addEventListener('click', function (e) {
          var want = (card.getAttribute('data-pick-color') || '').toLowerCase();
          var radio = qsa('[data-pdp-option] input', root).filter(function (r) {
            return r.value.toLowerCase() === want;
          })[0];
          if (!radio) return;
          e.preventDefault();
          if (!radio.checked) {
            radio.checked = true;
            radio.dispatchEvent(new Event('change', { bubbles: true }));
          }
          root.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      });

      // sync the gallery with the server-selected variant (e.g. ?variant= deep links)
      apply(findVariant(chosen()), false);
    });
  }

  var modalOpener = null;
  function openModal(m, opener) {
    if (!m || !m.hidden) return;
    modalOpener = opener || null;
    m.hidden = false;
    doc.body.style.overflow = 'hidden';
    var card = qs('.ck-modal__card', m),
      bg = qs('.ck-modal__bg', m);
    card.scrollTop = 0;
    var f = qs('input[type="email"]', m);
    if (f && !f.closest('form').hidden) f.focus({ preventScroll: true });
    else qs('.ck-modal__x', m).focus({ preventScroll: true });
    if (!fx) return;
    bg.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 280, easing: 'ease-out' });
    card.animate(
      [
        { opacity: 0, transform: 'translateY(28px) scale(.97)' },
        { opacity: 1, transform: 'none' },
      ],
      { duration: 480, easing: 'cubic-bezier(.2,.8,.2,1)' },
    );
  }
  function closeModal(m) {
    if (!m || m.hidden) return;
    var done = function () {
      m.hidden = true;
      doc.body.style.overflow = '';
      if (modalOpener && modalOpener.focus) modalOpener.focus({ preventScroll: true });
    };
    if (!fx) return done();
    qs('.ck-modal__card', m).animate([{ opacity: 1 }, { opacity: 0, transform: 'translateY(16px)' }], {
      duration: 220,
      fill: 'forwards',
    }).onfinish = function () {
      m.getAnimations({ subtree: true }).forEach(function (a) {
        a.cancel();
      });
      done();
    };
  }
  doc.addEventListener('click', function (e) {
    var op = e.target.closest && e.target.closest('[data-ck-modal-open]');
    if (op) {
      var m = doc.getElementById(op.getAttribute('data-ck-modal-open'));
      if (!m) return;
      var tags = qs('[data-waitlist-tags]', m),
        label = qs('[data-waitlist-for]', m);
      if (tags)
        tags.value = tags.getAttribute('data-base') + (op.dataset.waitlist ? ', waitlist-' + op.dataset.waitlist : '');
      if (label) label.textContent = op.dataset.waitlistName ? '→ ' + op.dataset.waitlistName : '';
      return openModal(m, op);
    }
    var cl = e.target.closest && e.target.closest('[data-ck-modal-close]');
    if (cl) closeModal(cl.closest('[data-ck-modal]'));
  });
  doc.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    qsa('[data-ck-modal]').forEach(function (m) {
      closeModal(m);
    });
  });

  /* ---------------- quick enquiry drawer ---------------- */
  var enqOpener = null;
  function enqOpen(drawer, opener, requirement) {
    if (!drawer || !drawer.hidden) return;
    enqOpener = opener || null;
    var form = qs('form', drawer),
      okEl = qs('[data-ck-ok]', drawer),
      sel = qs('select[name="contact[Requirement]"]', drawer),
      btn = qs('[data-morph-btn]', drawer);
    // reopening after a sent enquiry starts a fresh form
    if (form && form.hidden) {
      form.hidden = false;
      form.reset();
      if (okEl) okEl.hidden = true;
      if (btn) btn.classList.remove('is-done');
    }
    if (sel && requirement) {
      sel.value = requirement;
      sel.dispatchEvent(new Event('change', { bubbles: true }));
      enqFullLink(drawer, sel.value);
    }
    drawer.hidden = false;
    doc.body.style.overflow = 'hidden';
    var first = qs('input[name="contact[name]"]', drawer);
    if (first) first.focus({ preventScroll: true });
    if (!fx) return;
    qs('.ck-drawer__bg', drawer).animate([{ opacity: 0 }, { opacity: 1 }], { duration: 280, easing: 'ease-out' });
    qs('[data-enq-aside]', drawer).animate([{ transform: 'translateX(100%)' }, { transform: 'none' }], {
      duration: 520,
      easing: 'cubic-bezier(.22,1,.36,1)',
    });
  }
  function enqClose(drawer) {
    if (!drawer || drawer.hidden) return;
    var done = function () {
      drawer.hidden = true;
      doc.body.style.overflow = '';
      if (enqOpener && enqOpener.focus) enqOpener.focus({ preventScroll: true });
    };
    if (!fx) return done();
    qs('[data-enq-aside]', drawer).animate([{ transform: 'none' }, { transform: 'translateX(100%)' }], {
      duration: 280,
      easing: 'ease-in',
    }).onfinish = done;
  }
  // the "full enquiry page" link follows the chosen requirement
  function enqFullLink(drawer, value) {
    var link = qs('[data-enq-full]', drawer);
    if (!link) return;
    var page = 'data-full-contact';
    if (!value || value === drawer.getAttribute('data-req-equipment')) page = 'data-full-equipment';
    else if (value === drawer.getAttribute('data-req-corporate')) page = 'data-full-corporate';
    link.href = drawer.getAttribute(page) || link.href;
  }
  doc.addEventListener('click', function (e) {
    var op = e.target.closest && e.target.closest('[data-ck-enquiry-open]');
    if (op) {
      enqOpen(doc.getElementById(op.getAttribute('data-ck-enquiry-open')), op, op.getAttribute('data-requirement'));
      return;
    }
    var cl = e.target.closest && e.target.closest('[data-enq-close]');
    if (cl) enqClose(cl.closest('[data-ck-enquiry]'));
  });
  doc.addEventListener('change', function (e) {
    var sel = e.target;
    if (sel && sel.name === 'contact[Requirement]') {
      var d = sel.closest('[data-ck-enquiry]');
      if (d) enqFullLink(d, sel.value);
    }
  });
  doc.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    qsa('[data-ck-enquiry]').forEach(enqClose);
  });

  /* ---------------- Shopify's built-in policy pages: "On this page" list ---------------- */
  function initPolicyToc() {
    var box = qs('.shopify-policy__container');
    if (!box || !once(box, 'toc')) return;
    var body = qs('.shopify-policy__body', box);
    if (!body) return;
    // brand gradient on the last word of the page title
    var h1 = qs('.shopify-policy__title h1', box);
    if (h1 && !h1.querySelector('.ck-grad-text') && h1.children.length === 0) {
      var words = h1.textContent.trim().split(/\s+/);
      var last = words.pop();
      h1.textContent = words.length ? words.join(' ') + ' ' : '';
      var g = doc.createElement('span');
      g.className = 'ck-grad-text';
      g.textContent = last;
      h1.appendChild(g);
    }
    // Shopify policies are often written as bold numbered paragraphs ("1. Information We Collect"); turn those into real headings
    qsa('p', body).forEach(function (p) {
      var st = qsa('strong, b', p).filter(function (e) {
        return /^\d{1,2}\.\s+\S/.test(e.textContent.trim()) && e.textContent.trim().length < 120;
      })[0]; // Shopify's editor nests it, e.g. <p><span><strong><span>…
      if (!st) return;
      var t = st.textContent.trim();
      var top = st;
      while (top.parentNode !== p) top = top.parentNode;
      var m = /^(\d{1,2})\.\s+(.+)$/.exec(t);
      // the heading may share its paragraph with other text (before it, after it, or both)
      var after = [];
      for (var n = top.nextSibling; n; n = n.nextSibling) after.push(n);
      var rest = after.filter(function (n) {
        return n.nodeName !== 'BR' && n.textContent.trim();
      });
      var h = doc.createElement('h2');
      var num = doc.createElement('span');
      num.className = 'ck-policy-num';
      num.setAttribute('aria-hidden', 'true');
      num.textContent = ('0' + m[1]).slice(-2);
      var tt = doc.createElement('span');
      tt.className = 'ck-policy-ttl';
      tt.textContent = m[2];
      h.appendChild(num);
      h.appendChild(tt);
      h.setAttribute('data-toc', t);
      var tail = null;
      if (rest.length) {
        tail = doc.createElement('p');
        after.forEach(function (n) {
          tail.appendChild(n);
        });
      } else {
        after.forEach(function (n) {
          n.parentNode.removeChild(n);
        });
      }
      p.removeChild(top);
      while (p.lastChild && p.lastChild.nodeName === 'BR') p.removeChild(p.lastChild);
      if (!p.textContent.trim()) {
        p.parentNode.insertBefore(h, p);
        p.parentNode.removeChild(p);
      } else {
        p.parentNode.insertBefore(h, p.nextSibling);
      }
      if (tail) h.parentNode.insertBefore(tail, h.nextSibling);
    });
    var heads = qsa('h1, h2', body).filter(function (h) {
      return h.textContent.trim();
    });
    if (heads.length < 3) return;
    var nav = doc.createElement('nav');
    nav.className = 'shopify-policy__toc';
    nav.setAttribute('aria-label', 'On this page');
    var title = doc.createElement('div');
    title.className = 'shopify-policy__toc-title';
    title.textContent = 'ON THIS PAGE';
    var ul = doc.createElement('ul');
    var links = heads.map(function (h, i) {
      if (!h.id) h.id = 'policy-' + (i + 1);
      var li = doc.createElement('li'),
        a = doc.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.getAttribute('data-toc') || h.textContent.trim();
      li.appendChild(a);
      ul.appendChild(li);
      return a;
    });
    nav.appendChild(title);
    nav.appendChild(ul);
    box.insertBefore(nav, body);
    box.classList.add('has-toc');
    if ('IntersectionObserver' in window) {
      var spy = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (en) {
            if (!en.isIntersecting) return;
            links.forEach(function (a) {
              a.classList.toggle('is-on', a.getAttribute('href') === '#' + en.target.id);
            });
          });
        },
        { rootMargin: '-20% 0px -70% 0px' },
      );
      heads.forEach(function (h) {
        spy.observe(h);
      });
    }
  }

  /* ---------------- back from Shopify's spam check ----------------
     When Shopify asks a visitor to verify ("Your connection needs to be verified…"), the form is posted natively and the
     visitor lands back on the page with ?contact_posted=true / ?customer_posted=true. Show the same pop-up we show after
     an ajax send. */
  function initPostedNotice() {
    var q = new URLSearchParams(location.search);
    if (q.get('contact_posted') !== 'true' && q.get('customer_posted') !== 'true') return;
    // Shopify marks EVERY form of the same type on the page as sent. The form that was really posted is the one
    // named in the URL hash (its id); without a usable hash, fall back to the first form carrying the server marker.
    var anchor = location.hash ? doc.getElementById(location.hash.slice(1)) : null;
    var form = anchor && anchor.matches && anchor.matches('form[data-ck-ajax-form]') ? anchor : null;
    if (!form) {
      var mk = qs('[data-posted]');
      form = mk && mk.closest('form');
    }
    if (form) {
      var msg = formSentText(form);
      formSentShow(form);
      ckAlert('success', msg.title, msg.text);
    }
    q.delete('contact_posted');
    q.delete('customer_posted');
    // keep the address clean: no leftover #FormId (it would also scroll the page to that form)
    if (window.history && history.replaceState)
      history.replaceState(null, '', location.pathname + (q.toString() ? '?' + q.toString() : ''));
  }

  /* ---------------- cart page: +/- update the bag ---------------- */
  function initCartPage() {
    qsa('[data-ck-cart]').forEach(function (form) {
      if (!once(form, 'cartpage')) return;
      var upd = qs('[data-cart-update]', form);
      function send() {
        qsa('button, a.ck-cart__remove', form).forEach(function (b) {
          b.setAttribute('aria-disabled', 'true');
        });
        if (form.requestSubmit && upd) form.requestSubmit(upd);
        else if (upd) upd.click();
      }
      form.addEventListener('click', function (e) {
        var b = e.target.closest && e.target.closest('[data-cart-dec],[data-cart-inc]');
        if (!b) return;
        var input = qs('[data-cart-qty]', b.closest('.ck-qty')),
          n = parseInt(input.value, 10) || 1;
        input.value = b.hasAttribute('data-cart-inc') ? Math.min(99, n + 1) : Math.max(0, n - 1);
        send();
      });
      form.addEventListener('change', function (e) {
        if (e.target.matches && e.target.matches('[data-cart-qty]')) {
          e.target.value = Math.max(0, parseInt(e.target.value, 10) || 0);
          send();
        }
      });
    });
  }

  /* ---------------- phone / tablet menu sidebar ---------------- */
  var menuOpener = null;
  function menuOpen(m, opener) {
    if (!m || !m.hidden) return;
    menuOpener = opener || null;
    m.hidden = false;
    doc.body.style.overflow = 'hidden';
    var first = qs('.ck-menu__links a', m);
    if (first) first.focus({ preventScroll: true });
    if (!fx) return;
    qs('.ck-drawer__bg', m).animate([{ opacity: 0 }, { opacity: 1 }], { duration: 260, easing: 'ease-out' });
    qs('[data-menu-aside]', m).animate([{ transform: 'translateX(-100%)' }, { transform: 'none' }], {
      duration: 420,
      easing: 'cubic-bezier(.22,1,.36,1)',
    });
  }
  function menuClose(m) {
    if (!m || m.hidden) return;
    var done = function () {
      m.hidden = true;
      doc.body.style.overflow = '';
      if (menuOpener && menuOpener.focus) menuOpener.focus({ preventScroll: true });
    };
    if (!fx) return done();
    qs('[data-menu-aside]', m).animate([{ transform: 'none' }, { transform: 'translateX(-100%)' }], {
      duration: 240,
      easing: 'ease-in',
    }).onfinish = done;
  }
  doc.addEventListener('click', function (e) {
    var op = e.target.closest && e.target.closest('[data-ck-menu-open]');
    if (op) return menuOpen(qs('[data-ck-menu]'), op);
    var m = e.target.closest && e.target.closest('[data-ck-menu]');
    if (!m) return;
    // the close button, the dim background and any link inside close the sidebar
    if (e.target.closest('[data-menu-close]') || e.target.closest('a[href]')) menuClose(m);
  });
  doc.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') qsa('[data-ck-menu]').forEach(menuClose);
  });
  window.matchMedia &&
    matchMedia('(min-width: 900px)').addEventListener('change', function (e) {
      if (e.matches)
        qsa('[data-ck-menu]').forEach(function (m) {
          m.hidden = true;
          doc.body.style.overflow = '';
        });
    });

  /* ---------------- boot ---------------- */
  function init() {
    onScroll();
    initReveal();
    initScrub();
    initSpot();
    initFloat();
    initHeroTilt();
    initFeatured();
    initCards();
    initPdp();
    initPolicyToc();
    initPostedNotice();
    initCartPage();
    // Dawn's own add-to-cart (product-form.js, quick add, apps built on Dawn's pubsub) announces itself this way
    if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS && once(window, 'dawnsub'))
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function () {
        refreshCount(true);
      });
    if (fx) {
      initPointer();
    }
    force = true;
  }
  var started = false;
  function boot() {
    if (started) return;
    started = true;
    init();
    if (fx) requestAnimationFrame(frame);
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', boot);
  else boot();
  doc.addEventListener('shopify:section:load', function () {
    started && init();
  });
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) refreshCount(false);
  });
  refreshCount(false);
  setTheme(root.getAttribute('data-ck-theme') || 'dark');
})();
